import { render, staticRenderFns } from "./CategorySliderWidget.vue?vue&type=template&id=064819f4"
import script from "./CategorySliderWidget.vue?vue&type=script&lang=js"
export * from "./CategorySliderWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/65379/65/Stoffe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064819f4')) {
      api.createRecord('064819f4', component.options)
    } else {
      api.reload('064819f4', component.options)
    }
    module.hot.accept("./CategorySliderWidget.vue?vue&type=template&id=064819f4", function () {
      api.rerender('064819f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stoffe/CategorySliderWidget.vue"
export default component.exports